import { render } from "./currentCRMWhatsappInvoicePaymentView.vue?vue&type=template&id=62dfacf3"
import script from "./currentCRMWhatsappInvoicePaymentView.vue?vue&type=script&lang=js"
export * from "./currentCRMWhatsappInvoicePaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__